// utils/academicPeriod.js
import dayjs from "dayjs";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";

// 🔑 IMPORTANT: activate plugins
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);

export const isWithinRange = (date, start, end) =>
  date.isSameOrAfter(start, "day") &&
  date.isSameOrBefore(end, "day");

export const getAcademicMonths = (start, end) => {
  const months = [];
  let current = start.startOf("month");

  while (current.isSameOrBefore(end, "month")) {
    months.push({
      label: current.format("MMMM"),
      month: current.month() + 1,
      year: current.year(),
    });
    current = current.add(1, "month");
  }

  return months;
};

export const getAcademicYears = (start, end) => {
  const years = [];
  for (let y = start.year(); y <= end.year(); y++) {
    years.push(y);
  }
  return years;
};
